export default {
  role(state) {
    return state.organisation_user ? state.organisation_user.role.role : null
  },
  lastOrganisation() {
    let o = localStorage.getItem('last_organisation')
    if (!o) return null

    o = JSON.parse(o)
    let u = localStorage.getItem('last_organisation_user')
    if (!u) return null

    o.user = JSON.parse(u)

    return o
  },
}
